import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg';
import { RenewalsCustomConsumptionUploadComponent } from './pages/renewals-custom-consumption-upload/renewals-custom-consumption-upload.component';
import { RenewalsCustomContractDetailsComponent } from './pages/renewals-custom-contract-details/renewals-custom-contract-details.component';
import { RenewalsCustomCustomerDetailsComponent } from './pages/renewals-custom-customer-details/renewals-custom-customer-details.component';
import { RenewalsCustomFileValidationComponent } from './pages/renewals-custom-file-validation/renewals-custom-file-validation.component';
import { RenewalsCustomGetQuoteComponent } from './pages/renewals-custom-get-quote/renewals-custom-get-quote.component';
import { RenewalsCustomSupplyDetailsComponent } from './pages/renewals-custom-supply-details/renewals-custom-supply-details.component';
import { RenewalsCustomUtilityAccountsComponent } from './pages/renewals-custom-utility-accounts/renewals-custom-utility-accounts.component';
import { RenewalsCustomYoureDoneComponent } from './pages/renewals-custom-youre-done/renewals-custom-youre-done.component';

const routes: Routes = [
  { path: ':quoteRequestId/customer-details', component: RenewalsCustomCustomerDetailsComponent },
  { path: ':quoteRequestId/utility-accounts', component: RenewalsCustomUtilityAccountsComponent },
  { path: ':quoteRequestId/consumption-data', component: RenewalsCustomConsumptionUploadComponent },
  { path: ':quoteRequestId/file-validation', component: RenewalsCustomFileValidationComponent },
  { path: ':quoteRequestId/supply-details', component: RenewalsCustomSupplyDetailsComponent },
  { path: ':quoteRequestId/get-quote', component: RenewalsCustomGetQuoteComponent },
  { path: ':quoteRequestId/youre-done', component: RenewalsCustomYoureDoneComponent },
  { path: ':quoteRequestId/contract-details', component: RenewalsCustomContractDetailsComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    InlineSVGModule
  ],
  exports: [RouterModule]
})
export class RenewalsCustomRoutingModule { }
